import React from 'react';
import Desktop from './Desktop';
import Mobile from './Mobile';

const HomeEntitiesPage = () => {
    if(window.innerWidth < 791) {
        return <Mobile/>
    } else {
        return <Desktop/>
    }
};

export default HomeEntitiesPage;
